import router from "../router";

const initialState = {
  allowedRoutes: [],
  salesChannels: [],
  verificationMessage: null,
  isExpandedMenu: false,
  permissionsChanged: false,
  windowWidth: window.innerWidth,
}

export const app = {
  namespaced: true,
  state: initialState,

  mutations: {
    windowWidth(state) {
      state.windowWidth = window.innerWidth;
    },

    allowedRoutes(state, allowedRoutes) {
      state.allowedRoutes = allowedRoutes;
    },

    salesChannels(state, salesChannels) {
      state.salesChannels = salesChannels;
    },

    verificationMessage(state, verificationMessage) {
      state.verificationMessage = verificationMessage;
    },

    clearVerificationMessage(state) {
      state.verificationMessage = null;
    },

    isExpandedMenu(state, isExpanded) {
      state.isExpandedMenu = isExpanded;
    },

    SET_PERMISSIONS_CHANGED(state, payload) {
      state.permissionsChanged = !state.permissionsChanged;
    }
  },

  actions: {
    allowedRoutes({ commit }) {
      this.permissions = JSON.parse(localStorage.getItem('permissions'));
      let allowedRoutes = []
      let routes = router.options.routes.filter(route => route.meta && route.meta.isMenuItem === true)
      for(let i=0;i<routes.length;i++) {
        let route = routes[i]
        let isAllowed = this.permissions.some(permission => route.meta.permissions.includes(permission))
        if (isAllowed){
          allowedRoutes.push(route)
        }
      }
      allowedRoutes.sort((a, b) => (a.meta.position > b.meta.position) ? 1 : -1)
      localStorage.setItem("allowedRoutes", JSON.stringify(allowedRoutes))
    },
    salesChannels({ commit }) {
      this.permissions = JSON.parse(localStorage.getItem('permissions'));
      let  salesChannels = []
      let channels = router.options.routes.filter(route => route.meta && route.meta.isSalesChannel === true)
      for(let i=0;i<channels.length;i++) {
        let channel = channels[i]
        let isAllowed = this.permissions.some(permission => channel.meta.permissions.includes(permission))
        if (isAllowed){
          salesChannels.push(channel)
        }
      }
      localStorage.setItem("salesChannels", JSON.stringify(salesChannels))
    },

    setWindowWidth({ commit, state }) {
      commit('windowWidth');
    },

    setIsExpandedMenu({ commit, state }, payload) {
      commit('isExpandedMenu', payload);
    },

    setVerificationMessage({ commit, state }, payload) {
      commit('verificationMessage', payload);
    },

    clearVerificationMessage({ commit, state }) {
      commit('clearVerificationMessage');
    },

    updatePermissionsChanged({ commit }, payload) {
      commit('SET_PERMISSIONS_CHANGED', payload);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/app.module.js